const TABLEAU_LICENSE_USERS_QUESTION = 'tableau-license-users';

export const resolveTableauLicenseUsersAnswer = (
  questionName: string,
  answer: unknown,
  allAnswers: Record<string, unknown>,
): unknown => {
  if (questionName !== TABLEAU_LICENSE_USERS_QUESTION) return answer;

  const hasStoredAnswer =
    typeof answer === 'string'
      ? answer.trim().length > 0
      : Boolean(answer && typeof answer === 'object' && Object.keys(answer).length > 0);
  if (hasStoredAnswer) return answer;

  const requestedCount = String(allAnswers['number-of-tableau-users'] ?? '').trim();
  const forRequester = String(allAnswers['single-license-for-requester'] ?? '')
    .trim()
    .toLowerCase();
  const requesterEmail = String(allAnswers['tableau-contact-email'] ?? '').trim();

  if (requestedCount !== '1' || forRequester !== 'yes' || !requesterEmail) return answer;

  return { licenseUser1emailAddress: requesterEmail };
};
